import { render, staticRenderFns } from "./StatsUnit.vue?vue&type=template&id=0c16bc36&scoped=true&"
import script from "./StatsUnit.vue?vue&type=script&lang=ts&"
export * from "./StatsUnit.vue?vue&type=script&lang=ts&"
import style0 from "./StatsUnit.vue?vue&type=style&index=0&id=0c16bc36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16bc36",
  null
  
)

export default component.exports